import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Program } from '../../models/quotation-model/catalogs/program.model';
import {
  QuoterProgramPaged,
  QuoterProgram,
  QuoterProgramPersonPaged,
  QuoterProgramPerson,
} from '../../models/quotation-model/catalogs/quoterConfig/quoter-program.model';
import { environment } from '../../../../environments/environment';
import { CommonFilterRequest, CommonResult } from '../../models/quotation-model/customer.model';

@Injectable({
  providedIn: 'root',
})
export class ProgramService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getPrograms(modelId: number, planId: number): Observable<Program[]> {
    return this.http.get<Program[]>(
      this.URL_API + '/Program?modelId=' + modelId + '&planId=' + planId,
    );
  }

  getProgramsToDealer(dealerPlanId: number): Observable<Program[]> {
    return this.http.get<Program[]>(
      this.URL_API + '/Program/GetProgramsToDealer?dealerPlanId=' + dealerPlanId,
    );
  }

  getPagedPrograms(filters: CommonFilterRequest): Observable<QuoterProgramPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '');
    return this.http.get<QuoterProgramPaged>(this.URL_API + '/Program/GetPagedPrograms', {
      params,
    });
  }

  upsertQuoterProgram(upsertProgram: QuoterProgram) {
    return this.http.post<CommonResult>(this.URL_API + '/Program/UpsertProgram', upsertProgram);
  }

  getPagedProgramPersons(
    filters: CommonFilterRequest,
    programId: number,
  ): Observable<QuoterProgramPersonPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ? filters.filter : '')
      .set('ProgramId', programId);
    return this.http.get<QuoterProgramPersonPaged>(
      this.URL_API + '/Program/GetPagedProgramPersons',
      {
        params,
      },
    );
  }

  upsertQuoterProgramPerson(upsertProgramPerson: QuoterProgramPerson) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Program/UpsertProgramPerson',
      upsertProgramPerson,
    );
  }
}
